import { createFileRoute } from '@tanstack/react-router';

import { batchAssignmentListScreen, batchAssignmentListSearch, loadBatchAssignmentListScreen, loadBatchAssignmentMessages } from '@/modules/batch-assignment/route';
import { lazyScreen } from '@/shared/screen';

// Cessões no caminho do legado (`router.tsx:1241-1249`): `screens.byPath` acha o manifesto e o menu vira
// link interno. Arquivo leve (JS inicial); a tela vem em chunk próprio.
export const Route = createFileRoute('/_app/ccb/cessoes/')({
  validateSearch: batchAssignmentListSearch,
  staticData: { screen: batchAssignmentListScreen },
  loader: loadBatchAssignmentMessages,
  component: lazyScreen(loadBatchAssignmentListScreen, 'BatchAssignmentListScreen'),
});
